import Vue from 'vue';
import Vuex from 'vuex';
// import V4Vuex from '../common/components/util/v4vuex/V4Vuex';
// import validators from '@/vuex/validations';
import { CustomerState, customerState } from '@/customer/vuex/store';
import { ScheduleRuleState, scheduleRuleState } from '@/rule/vuex/store';
import { MassState, massState } from '@/mass/vuex/store';
import customerMutations from '@/customer/vuex/mutations';
import scheduleRuleMutations from '@/rule/vuex/mutations';
import massMutations from '@/mass/vuex/mutations';
import userMutations from '@/user/vuex/mutations';
import accountMutations from '@/account/vuex/mutations';
import upgradeMutations from '@/upgrade/vuex/mutations';
import { UpgradeState, upgradeState } from '@/upgrade/vuex/store';
import commonMutations from '@/common/vuex/mutations';
import settingsMutations from '@/settings/vuex/mutations';
import { AccountState, accountState } from '@/common/models/Account';
import { CommonState, commonState } from '@/common/vuex/store';

Vue.use(Vuex);

export interface AppState {
  customerState: CustomerState;
  scheduleRuleState: ScheduleRuleState;
  massState: MassState;
  accountState: AccountState;
  commonState: CommonState;
  upgradeState: UpgradeState;
}


const store = new Vuex.Store({
  state: {
    customerState,
    scheduleRuleState,
    massState,
    accountState,
    commonState,
    upgradeState,
  },
  mutations: {
    ...customerMutations,
    ...scheduleRuleMutations,
    ...massMutations,
    ...userMutations,
    ...commonMutations,
    ...settingsMutations,
    ...accountMutations,
    ...upgradeMutations,
  },
});

// Vue.use(V4Vuex, {
//   validators,
// });

export default store;

